import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForJsmStorageOverLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		canUpgrade,
		canDirectBuyUpgrade,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	return (
		product === 'jira-service-management' &&
		edition === 'free' &&
		!!(canUpgrade || canDirectBuyUpgrade) &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB &&
		fg('jsmgrowth-267_-_enforce_storage_limits')
	);
}
